import { proxyCustomElement, HTMLElement, createEvent, h, Host, Fragment } from '@stencil/core/internal/client';
import { c as convertMBToBytes, b as getExtensionsList, g as getExtension, E as EXTENSION_TO_TYPE, m as modifyPropertiesOnFile, a as getBaseName, r as renameFile, d as defineCustomElement$L } from './wpp-file-upload-item2.js';
import { W as WrappedSlot } from './WrappedSlot.js';
import { g as getSlotEmptyStates } from './utils.js';
import { l as lodash } from './lodash.js';
import { d as defineCustomElement$M } from './wpp-action-button2.js';
import { d as defineCustomElement$K } from './wpp-icon-attach2.js';
import { d as defineCustomElement$J } from './wpp-icon-blockquote2.js';
import { d as defineCustomElement$I } from './wpp-icon-bold2.js';
import { d as defineCustomElement$H } from './wpp-icon-code-view2.js';
import { d as defineCustomElement$G } from './wpp-icon-cross2.js';
import { d as defineCustomElement$F } from './wpp-icon-database2.js';
import { d as defineCustomElement$E } from './wpp-icon-document2.js';
import { d as defineCustomElement$D } from './wpp-icon-error2.js';
import { d as defineCustomElement$C } from './wpp-icon-file2.js';
import { d as defineCustomElement$B } from './wpp-icon-file-zip2.js';
import { d as defineCustomElement$A } from './wpp-icon-float-center2.js';
import { d as defineCustomElement$z } from './wpp-icon-float-left2.js';
import { d as defineCustomElement$y } from './wpp-icon-float-right2.js';
import { d as defineCustomElement$x } from './wpp-icon-h12.js';
import { d as defineCustomElement$w } from './wpp-icon-h22.js';
import { d as defineCustomElement$v } from './wpp-icon-image2.js';
import { d as defineCustomElement$u } from './wpp-icon-indent-decrease2.js';
import { d as defineCustomElement$t } from './wpp-icon-indent-increase2.js';
import { d as defineCustomElement$s } from './wpp-icon-info2.js';
import { d as defineCustomElement$r } from './wpp-icon-italic2.js';
import { d as defineCustomElement$q } from './wpp-icon-link2.js';
import { d as defineCustomElement$p } from './wpp-icon-mic-on2.js';
import { d as defineCustomElement$o } from './wpp-icon-music2.js';
import { d as defineCustomElement$n } from './wpp-icon-ordered-list2.js';
import { d as defineCustomElement$m } from './wpp-icon-pitch2.js';
import { d as defineCustomElement$l } from './wpp-icon-redo2.js';
import { d as defineCustomElement$k } from './wpp-icon-send2.js';
import { d as defineCustomElement$j } from './wpp-icon-spreadsheet2.js';
import { d as defineCustomElement$i } from './wpp-icon-strike-through2.js';
import { d as defineCustomElement$h } from './wpp-icon-success2.js';
import { d as defineCustomElement$g } from './wpp-icon-text-alignment-center2.js';
import { d as defineCustomElement$f } from './wpp-icon-text-alignment-justify2.js';
import { d as defineCustomElement$e } from './wpp-icon-text-alignment-left2.js';
import { d as defineCustomElement$d } from './wpp-icon-text-alignment-right2.js';
import { d as defineCustomElement$c } from './wpp-icon-underline2.js';
import { d as defineCustomElement$b } from './wpp-icon-undo2.js';
import { d as defineCustomElement$a } from './wpp-icon-unordered-list2.js';
import { d as defineCustomElement$9 } from './wpp-icon-video-clip2.js';
import { d as defineCustomElement$8 } from './wpp-icon-warning2.js';
import { d as defineCustomElement$7 } from './wpp-inline-message2.js';
import { d as defineCustomElement$6 } from './wpp-internal-tooltip2.js';
import { d as defineCustomElement$5 } from './wpp-spinner2.js';
import { d as defineCustomElement$4 } from './wpp-toast2.js';
import { d as defineCustomElement$3 } from './wpp-tooltip2.js';
import { d as defineCustomElement$2 } from './wpp-typography2.js';

const TOAST_DURATION = 5000;

const DEFAULT_FILE_UPLOAD_CONFIG = {
  acceptConfig: {},
  accept: [],
  size: 50,
  maxFiles: 5,
  multiple: true,
  showOnlyNewErrors: false,
  controlled: false,
  locales: {
    sizeError: 'File exceeds the allowed size limit',
    formatError: 'Invalid file format',
  },
};

const wppChatInputCss = ":host{--chat-input-container-min-width:var(--wpp-chat-input-container-min-width, 320px);--chat-input-container-max-width:var(--wpp-chat-input-container-max-width, 720px);--chat-input-container-bg-color:var(--wpp-chat-input-container-bg-color, var(--wpp-grey-color-000));--chat-input-container-outline-width:var(--wpp-chat-input-container-outline-width, 1px);--chat-input-container-outline-style:var(--wpp-chat-input-container-outline-style, solid);--chat-input-container-outline-color:var(--wpp-chat-input-container-outline-color, var(--wpp-grey-color-500));--chat-input-container-outline-color-hover:var(--wpp-chat-input-container-outline-color-hover, var(--wpp-grey-color-700));--chat-input-container-outline-color-active:var(--wpp-chat-input-container-outline-color-active, var(--wpp-grey-color-800));--chat-input-container-outline-color-disabled:var(--wpp-chat-input-container-outline-color-disabled, var(--wpp-grey-color-400));--chat-input-container-border-radius:var(--wpp-chat-input-container-border-radius, 8px);--chat-input-area-min-height:var(--wpp-chat-input-area-min-height, 52px);--chat-input-area-max-height:var(--wpp-chat-input-area-max-height, 240px);--chat-input-area-padding:var(--wpp-chat-input-area-padding, 12px 6px 0 12px);--chat-input-area-placeholder-color:var(--wpp-chat-input-area-placeholder-color, var(--wpp-grey-color-700));--chat-text-input-min-height:var(--wpp-chat-text-input-min-height, 52px);--chat-text-input-padding:var(--wpp-chat-text-input-padding, 0);--chat-text-input-bg-color:var(--wpp-chat-text-input-bg-color, transparent);--chat-text-input-color-disabled:var(--wpp-chat-text-input-color-disabled, var(--wpp-grey-color-500));--chat-text-input-placeholder-color:var(--wpp-chat-text-input-placeholder-color, var(--wpp-grey-color-700));--chat-text-input-placeholder-color-disabled:var(--wpp-chat-text-input-placeholder-color-disabled, var(--wpp-text-color-disabled));--chat-actions-bar-padding:var(--wpp-chat-actions-bar-padding, 0 10px 8px 10px);--chat-actions-bar-color:var(--wpp-chat-actions-bar-color, var(--wpp-grey-color-500));--chat-actions-bar-color-disabled:var(--wpp-chat-actions-bar-color-disabled, var(--wpp-grey-color-400));--chat-actions-bar-char-counter-color:var(--wpp-chat-actions-bar-char-counter-color, var(--wpp-danger-color-500));--chat-actions-bar-char-counter-color-disabled:var(--wpp-chat-actions-bar-char-counter-color-disabled, var(--wpp-danger-color-300));display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;-ms-flex-align:center;align-items:center;width:100%;z-index:100}.chat-input-container{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;position:absolute;bottom:100%;background-color:var(--chat-input-container-bg-color);gap:8px;outline:var(--chat-input-container-outline-width) var(--chat-input-container-outline-style) var(--chat-input-container-outline-color);border-radius:var(--chat-input-container-border-radius);min-width:var(--chat-input-container-min-width);max-width:var(--chat-input-container-max-width);-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transition:width 0.2s ease, height 0.2s ease;transition:width 0.2s ease, height 0.2s ease;cursor:text}.chat-input-container:hover{outline:var(--chat-input-container-outline-width) var(--chat-input-container-outline-style) var(--chat-input-container-outline-color-hover)}.chat-input-container:active{outline:var(--chat-input-container-outline-width) var(--chat-input-container-outline-style) var(--chat-input-container-outline-color-active)}.chat-input-container.disabled{pointer-events:none;cursor:not-allowed;outline:var(--chat-input-container-outline-width) var(--chat-input-container-outline-style) var(--chat-input-container-outline-color-disabled)}.chat-file-upload-toast{position:absolute;top:8px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);cursor:pointer;z-index:2000}.input-area{font-size:var(--wpp-typography-s-body-font-size, 14px);line-height:var(--wpp-typography-s-body-line-height, 22px);font-weight:var(--wpp-typography-s-body-font-weight, 400);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--wpp-grey-color-1000);min-height:var(--chat-input-area-min-height);max-height:var(--chat-input-area-max-height);overflow-y:hidden;-ms-flex:1;flex:1;padding:var(--chat-input-area-padding);gap:12px;box-sizing:border-box;border-radius:8px 8px 0 0;scrollbar-gutter:stable;scrollbar-width:thin;scrollbar-color:var(--wpp-grey-color-400) transparent}.input-area::-webkit-input-placeholder{color:var(--chat-input-area-placeholder-color)}.input-area::-moz-placeholder{color:var(--chat-input-area-placeholder-color)}.input-area:-ms-input-placeholder{color:var(--chat-input-area-placeholder-color)}.input-area::-ms-input-placeholder{color:var(--chat-input-area-placeholder-color)}.input-area::placeholder{color:var(--chat-input-area-placeholder-color)}.input-area::-webkit-scrollbar{width:4px;height:4px}.input-area::-webkit-scrollbar-thumb{background-color:var(--wpp-grey-color-400);border-radius:4px;margin:6px}.input-area::-webkit-scrollbar-track{background:transparent}.input-area textarea{width:100%;min-height:var(--chat-text-input-min-height);resize:none;border:none;outline:none;padding:var(--chat-text-input-padding);font-family:inherit;font-weight:inherit;font-size:inherit;line-height:inherit;background-color:var(--chat-text-input-bg-color);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;color:inherit}.input-area textarea::-webkit-input-placeholder{color:var(--chat-text-input-placeholder-color)}.input-area textarea::-moz-placeholder{color:var(--chat-text-input-placeholder-color)}.input-area textarea:-ms-input-placeholder{color:var(--chat-text-input-placeholder-color)}.input-area textarea::-ms-input-placeholder{color:var(--chat-text-input-placeholder-color)}.input-area textarea::placeholder{color:var(--chat-text-input-placeholder-color)}.input-area textarea:disabled{cursor:not-allowed;color:var(--chat-text-input-color-disabled)}.input-area textarea:disabled::-webkit-input-placeholder{color:var(--chat-text-input-placeholder-color-disabled)}.input-area textarea:disabled::-moz-placeholder{color:var(--chat-text-input-placeholder-color-disabled)}.input-area textarea:disabled:-ms-input-placeholder{color:var(--chat-text-input-placeholder-color-disabled)}.input-area textarea:disabled::-ms-input-placeholder{color:var(--chat-text-input-placeholder-color-disabled)}.input-area textarea:disabled::placeholder{color:var(--chat-text-input-placeholder-color-disabled)}.actions-bar{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:end;align-items:flex-end;padding:var(--chat-actions-bar-padding);border-radius:0 0 8px 8px}.actions-bar .left-actions{display:-ms-flexbox;display:flex;gap:4px;-ms-flex-align:center;align-items:center}.actions-bar .left-actions .select{display:-ms-flexbox;display:flex;width:100%}.actions-bar .left-actions .wpp-action-button::part(button){color:var(--chat-actions-bar-color)}.actions-bar .left-actions.disabled .wpp-action-button::part(button){cursor:not-allowed;color:var(--chat-actions-bar-color-disabled)}.actions-bar .right-actions{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;gap:8px}.actions-bar .right-actions .char-counter{color:var(--chat-actions-bar-char-counter-color)}.actions-bar .right-actions .wpp-action-button::part(button){color:var(--chat-actions-bar-color)}.actions-bar .right-actions.disabled .wpp-action-button::part(button){cursor:not-allowed;color:var(--chat-actions-bar-color-disabled)}.actions-bar .right-actions.disabled .char-counter{color:var(--chat-actions-bar-char-counter-color-disabled)}.attachments{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:4px;width:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease}.attachments .wpp-file-upload-item{width:100%}.attachments .wpp-file-upload-item::part(file-item){margin-top:0}";

const WppChatInput$1 = /*@__PURE__*/ proxyCustomElement(class WppChatInput extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.wppSend = createEvent(this, "wppSend", 1);
    this.wppMic = createEvent(this, "wppMic", 1);
    this.wppChange = createEvent(this, "wppChange", 1);
    this.wppFileUploadItemDelete = createEvent(this, "wppFileUploadItemDelete", 1);
    this.wppFileUploadItemClick = createEvent(this, "wppFileUploadItemClick", 1);
    this.scrollTimeout = null;
    this.MIN_TEXTAREA_HEIGHT = 52;
    this.MAX_INPUT_AREA_HEIGHT = 240;
    this.reInitValue = (list) => {
      this.successAttachmentsList = list.filter(file => !this.isFileWithError(file));
      this.errorAttachmentsList = list.filter(this.isFileWithError);
    };
    this.updateSlotData = () => {
      const emptyStates = getSlotEmptyStates(this.host.childNodes, {
        select: '[slot="select"]',
      });
      this.hasSelectSlot = !emptyStates.select;
    };
    this.handleScroll = () => {
      if (this.scrollTimeout)
        clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.checkAttachmentsVisibility();
      }, 100);
    };
    this.adjustTextareaHeight = (reset = false) => {
      if (!this.textareaRef || !this.inputAreaRef)
        return;
      if (reset) {
        this.textareaRef.style.minHeight = `${this.MIN_TEXTAREA_HEIGHT}px`;
        return;
      }
      const attachmentsHeight = this.inputAreaRef.querySelector('.attachments')?.scrollHeight || 0;
      const textAreaContentHeight = this.calculateTextHeight(this.message) || this.MIN_TEXTAREA_HEIGHT;
      const totalHeight = attachmentsHeight + textAreaContentHeight;
      this.inputAreaRef.style.overflowY = totalHeight > this.MAX_INPUT_AREA_HEIGHT ? 'auto' : 'hidden';
      this.textareaRef.style.minHeight = `${Math.max(textAreaContentHeight, this.MIN_TEXTAREA_HEIGHT)}px`;
    };
    this.isFileWithError = (file) => !!(file.formatError || file.sizeError || file.validatorError);
    this.handleDeleteItem = (event) => {
      const { name, size } = event.detail;
      const updatedFilesList = this.attachments.filter(file => file.name + file.size !== name + size);
      this.successAttachmentsList = updatedFilesList.filter(file => !this.isFileWithError(file));
      this.errorAttachmentsList = updatedFilesList.filter(this.isFileWithError);
      if (this.inputRef)
        this.inputRef.value = '';
      this.wppChange.emit({
        value: this.successAttachmentsList,
        hasError: this.errorAttachmentsList.length > 0,
        errorFiles: this.errorAttachmentsList,
      });
      this.wppFileUploadItemDelete.emit(event.detail);
      this.attachments = updatedFilesList;
    };
    this.handleClickItem = (event) => this.wppFileUploadItemClick.emit(event.detail);
    this.handleChange = async () => {
      const files = this.inputRef?.files;
      if (!files?.length)
        return;
      this.displayToast('Uploading...', 'information');
      const filesToLoad = this.mergedFileUploadConfig.multiple ? Array.from(files) : [files[0]];
      await this.handleFileLoad(filesToLoad);
      requestAnimationFrame(() => this.adjustTextareaHeight());
      if (this.inputRef)
        this.inputRef.value = '';
    };
    this.isMaximumFilesSet = () => (this.mergedFileUploadConfig.maxFiles ?? 0) > 0;
    this.validateFileSize = (file) => {
      if (file.size > convertMBToBytes(this.mergedFileUploadConfig.size ?? 0)) {
        file.sizeError = true;
      }
      else {
        file.sizeError = false;
      }
      return file;
    };
    this.isAcceptConfigFilled = () => !!this.mergedFileUploadConfig.acceptConfig && Object.keys(this.mergedFileUploadConfig.acceptConfig).length > 0;
    this.getAcceptExtensions = () => {
      if (this.isAcceptConfigFilled()) {
        return getExtensionsList(this.mergedFileUploadConfig.acceptConfig || {});
      }
      return this.mergedFileUploadConfig.accept || [];
    };
    this.validateFileType = (file) => {
      if (this.isAcceptConfigFilled()) {
        const allowedExtensions = file.type
          ? this.mergedFileUploadConfig.acceptConfig?.[file.type] || []
          : this.getAcceptExtensions();
        file.formatError = allowedExtensions.length > 0 ? !allowedExtensions.includes(getExtension(file.name)) : true;
        return file;
      }
      if (!this.mergedFileUploadConfig.accept?.length) {
        if (!file.type) {
          const typeFromExtension = EXTENSION_TO_TYPE[getExtension(file.name)];
          return modifyPropertiesOnFile(file, { type: typeFromExtension });
        }
        return file;
      }
      file.formatError = !this.mergedFileUploadConfig.accept.some(format => {
        const normalizedFormat = format.replace(/[,.*]/g, '');
        return normalizedFormat === 'mov'
          ? file.type?.includes('quicktime')
          : /txt|text|msword|document|doc?x/.test(normalizedFormat)
            ? /text|application/.test(file.type)
            : file.type.includes(normalizedFormat);
      });
      return file;
    };
    this.customValidation = (file) => {
      file.validatorError = this.mergedFileUploadConfig.validator?.(file) || undefined;
      return file;
    };
    this.displayErrorListByShowingOption = (newFilesWithErrors) => this.mergedFileUploadConfig.showOnlyNewErrors
      ? newFilesWithErrors
      : [...this.errorAttachmentsList, ...newFilesWithErrors];
    this.generateUniqueName = (fileName, fileList) => {
      const baseName = getBaseName(fileName);
      const extension = getExtension(fileName);
      let counter = 1;
      const isNameTaken = (file) => {
        const currentCounter = counter;
        return file.name === `${baseName}-${currentCounter}${extension}`;
      };
      while (fileList.some(file => isNameTaken(file))) {
        counter++;
      }
      return `${baseName}-${counter}${extension}`;
    };
    this.handleClick = () => {
      if (!this.disabled) {
        this.textareaRef?.focus();
      }
    };
    this.hostCssClasses = () => ({
      'wpp-chat-input': true,
    });
    this.chatToastClasses = () => ({
      'chat-file-upload-toast': true,
    });
    this.chatInputContainerClasses = () => ({
      'chat-input-container': true,
      disabled: this.disabled,
    });
    this.inputAreaClasses = () => ({
      'input-area': true,
    });
    this.attachmentsWrapperClasses = () => ({
      attachments: true,
    });
    this.textInputClasses = () => ({
      'text-input': true,
    });
    this.actionsBarClasses = () => ({
      'actions-bar': true,
    });
    this.leftActionsClasses = () => ({
      'left-actions': true,
      disabled: this.disabled,
    });
    this.selectClasses = () => ({
      select: true,
      'slot-hidden': !this.hasSelectSlot,
      disabled: this.disabled,
    });
    this.rightActionsClasses = () => ({
      'right-actions': true,
      disabled: this.disabled,
    });
    this.placeholder = 'Type your message...';
    this.enableAttach = false;
    this.enableMic = false;
    this.disabled = false;
    this.fileUploadConfig = {
      /**
       * Format of the file upload result.
       */
      format: 'base64',
      /**
       * Maximum label length (in characters) of single item
       */
      maxLabelLength: 30,
      /**
       * If `true`, allows multiple files to be uploaded at once.
       */
      multiple: true,
      /**
       * Maximum number of files allowed for upload.
       * Set to `0` for no restriction.
       */
      maxFiles: 0,
      /**
       * Maximum allowed size of each file in MB.
       */
      size: 150,
      /**
       * Accept file format, you can pass any format you want download, by default is `.jpg, .jpeg, .png`
       *
       * @deprecated - this prop will be deleted in 3.0.0 version as it is not flexible enough to handle different
       * cases with files validations, for example based on mimetype and extension at the same time.
       * This property handle only a few extensions: ['.jpg', '.jpeg', '.png', '.txt', '.text', '.doc', '.docx', '.mov'],
       * and list will NOT be extended.
       *
       * If you want to use this prop, use "acceptConfig" property instead.
       * Note: "acceptConfig" property will have a higher priority in case if both "acceptConfig" and "accept" props will be provided
       */
      accept: ['.jpg', '.jpeg', '.png'],
      /**
       * Object defining accepted MIME types and their corresponding extensions.
       * Example: `{ 'image/png': ['.png'], 'application/pdf': ['.pdf'] }`.
       * Overrides `accept` if both are provided.
       */
      acceptConfig: {},
      /**
       * Defines custom validation function for uploaded files.
       * Should return `null` if the file is valid, or a string error message otherwise.
       */
      validator: () => null,
      /**
       * If `true`, replaces existing error messages with new ones for failed uploads.
       * If `false`, retains existing errors and appends new ones.
       */
      showOnlyNewErrors: false,
      /**
       * If `true`, the file upload works as controlled component.
       */
      controlled: false,
      /**
       * Indicates locales for file upload component
       */
      locales: {
        sizeError: 'File exceeds size limit',
        formatError: 'Wrong format',
      },
    };
    this.charactersLimit = undefined;
    this.attachments = [];
    this.withSelect = false;
    this.message = '';
    this.successAttachmentsList = [];
    this.errorAttachmentsList = [];
    this.toastMessage = '';
    this.toastType = 'information';
    this.showToast = false;
    this.isAnyFileUploading = false;
    this.areAttachmentsVisible = true;
    this.hasSelectSlot = false;
  }
  onAttachmentsChange(newValue) {
    if (this.mergedFileUploadConfig.controlled) {
      this.reInitValue(newValue);
    }
    requestAnimationFrame(() => this.adjustTextareaHeight());
  }
  componentWillLoad() {
    const list = [...this.attachments, ...(this.successAttachmentsList || []), ...(this.errorAttachmentsList || [])];
    this.reInitValue(list);
  }
  componentDidLoad() {
    requestAnimationFrame(() => {
      this.initializeObserver();
    });
    const debouncedResizeHandler = lodash.debounce(() => {
      if (this.textareaRef) {
        this.textareaRef.style.height = 'auto';
        this.forceRecalculateHeight();
        this.adjustTextareaHeight();
      }
    }, 150);
    const resizeObserver = new ResizeObserver(() => {
      debouncedResizeHandler();
    });
    if (this.inputAreaRef) {
      resizeObserver.observe(this.inputAreaRef);
    }
    this.resizeObserver = resizeObserver;
  }
  disconnectedCallback() {
    this.disconnectObserver();
    if (this.resizeObserver && this.inputAreaRef) {
      this.resizeObserver.unobserve(this.inputAreaRef);
    }
  }
  forceRecalculateHeight() {
    if (this.textareaRef) {
      const currentValue = this.textareaRef.value;
      this.textareaRef.value = '';
      this.textareaRef.value = currentValue;
    }
  }
  calculateTextHeight(text) {
    if (!this.textareaRef)
      return this.MIN_TEXTAREA_HEIGHT;
    const mirrorDiv = document.createElement('div');
    const computedStyle = window.getComputedStyle(this.textareaRef);
    mirrorDiv.style.position = 'absolute';
    mirrorDiv.style.visibility = 'hidden';
    mirrorDiv.style.whiteSpace = 'pre-wrap';
    mirrorDiv.style.wordWrap = 'break-word';
    mirrorDiv.style.padding = computedStyle.padding;
    mirrorDiv.style.width = this.textareaRef.offsetWidth + 'px';
    mirrorDiv.style.fontFamily = computedStyle.fontFamily;
    mirrorDiv.style.fontSize = computedStyle.fontSize;
    mirrorDiv.style.lineHeight = computedStyle.lineHeight;
    mirrorDiv.style.boxSizing = computedStyle.boxSizing;
    mirrorDiv.textContent = text || ' ';
    document.body.appendChild(mirrorDiv);
    const height = mirrorDiv.offsetHeight;
    document.body.removeChild(mirrorDiv);
    return height;
  }
  // Getter to merge defaults with provided config
  get mergedFileUploadConfig() {
    return {
      ...DEFAULT_FILE_UPLOAD_CONFIG,
      ...this.fileUploadConfig, // Merge with any provided config
    };
  }
  checkAttachmentsVisibility() {
    const attachmentsElement = this.inputAreaRef?.querySelector('.attachments');
    if (!attachmentsElement || !this.inputAreaRef) {
      this.areAttachmentsVisible = false;
      return;
    }
    const { top: inputTop, bottom: inputBottom } = this.inputAreaRef.getBoundingClientRect();
    const { top: attachTop, bottom: attachBottom } = attachmentsElement.getBoundingClientRect();
    this.areAttachmentsVisible = attachTop >= inputTop && attachBottom <= inputBottom;
  }
  disconnectObserver() {
    if (this.inputAreaRef) {
      this.inputAreaRef.removeEventListener('scroll', this.handleScroll);
    }
  }
  initializeObserver() {
    if (!this.inputAreaRef)
      return;
    this.inputAreaRef.addEventListener('scroll', this.handleScroll);
    this.checkAttachmentsVisibility();
  }
  scrollToTopOfAttachments() {
    if (this.inputAreaRef) {
      this.inputAreaRef.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  scrollToBottomOfAttachments() {
    const attachmentsElement = this.inputAreaRef?.querySelector('.attachments');
    if (!attachmentsElement) {
      console.error('🚀 Attachments container not found.');
      return;
    }
    const failedAttachment = attachmentsElement.querySelector('.wpp-file-upload-item.error');
    if (failedAttachment) {
      failedAttachment.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }
    attachmentsElement.scrollTo({ top: attachmentsElement.scrollHeight, behavior: 'smooth' });
  }
  displayToast(message, type) {
    this.checkAttachmentsVisibility();
    if (this.areAttachmentsVisible || !this.attachments?.length) {
      return;
    }
    this.toastMessage = message;
    this.toastType = type;
    this.showToast = true;
    setTimeout(() => (this.showToast = false), TOAST_DURATION);
  }
  handleSend() {
    if (this.disabled ||
      (!this.message.trim() && !this.successAttachmentsList.length) ||
      this.errorAttachmentsList.length)
      return;
    this.wppSend.emit({
      message: this.message.trim(),
      attachments: this.successAttachmentsList,
    });
    Object.assign(this, {
      message: '',
      successAttachmentsList: [],
      errorAttachmentsList: [],
    });
    this.wppChange.emit({ value: [], hasError: false, errorFiles: [] });
    this.adjustTextareaHeight(true);
  }
  scrollInputAreaToBottom() {
    if (!this.inputAreaRef)
      return;
    // Use a nested RAF and setTimeout fallback to let the DOM update.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.inputAreaRef.scrollTo({
          top: this.inputAreaRef.scrollHeight,
          behavior: 'smooth',
        });
        // Fallback in case the nested RAF doesn't work as expected.
        setTimeout(() => {
          this.inputAreaRef.scrollTo({
            top: this.inputAreaRef.scrollHeight,
            behavior: 'smooth',
          });
        }, 50);
      });
    });
  }
  handleInput(event) {
    if (this.disabled)
      return;
    const target = event.target;
    this.message = target.value;
    if (!this.message.trim() && this.textareaRef) {
      this.textareaRef.style.minHeight = `${this.MIN_TEXTAREA_HEIGHT}px`;
    }
    requestAnimationFrame(() => {
      this.adjustTextareaHeight();
      this.scrollInputAreaToBottom();
    });
  }
  handleFileSelection() {
    if (this.inputRef) {
      this.inputRef.click();
    }
  }
  async handleFileLoad(filesList) {
    if (!filesList.length)
      return;
    const existingAttachments = [...this.successAttachmentsList, ...this.errorAttachmentsList];
    const filteredFiles = filesList
      .filter(Boolean)
      .map(file => existingAttachments.some(item => item.name === file.name)
      ? renameFile(file, this.generateUniqueName(file.name, existingAttachments))
      : file);
    if (this.isMaximumFilesSet()) {
      const remainingSlots = Math.max(0, (this.mergedFileUploadConfig.maxFiles ?? 0) - existingAttachments.length);
      filteredFiles.length = this.mergedFileUploadConfig.multiple ? Math.min(filteredFiles.length, remainingSlots) : 1;
    }
    if (!filteredFiles.length)
      return;
    const validatedFiles = filteredFiles.map(file => {
      if ('url' in file)
        return file;
      this.validateFileSize(file);
      this.validateFileType(file);
      this.customValidation(file);
      return file;
    });
    const [batchSuccessFiles, batchErrorFiles] = [
      validatedFiles.filter(file => !this.isFileWithError(file)),
      validatedFiles.filter(this.isFileWithError),
    ];
    this.successAttachmentsList = [...this.successAttachmentsList, ...batchSuccessFiles];
    this.errorAttachmentsList = this.displayErrorListByShowingOption(batchErrorFiles);
    this.attachments = [...this.successAttachmentsList, ...this.errorAttachmentsList];
    this.wppChange.emit({
      value: this.successAttachmentsList,
      hasError: !!this.errorAttachmentsList.length,
      errorFiles: this.errorAttachmentsList,
    });
    requestAnimationFrame(() => {
      this.checkAttachmentsVisibility();
      const label = batchErrorFiles.length > 0 ? 'Upload FAILED' : 'Uploaded Successfully';
      const fileCount = batchErrorFiles.length || batchSuccessFiles.length;
      const fileLabel = fileCount === 1 ? 'File' : 'Files';
      if (fileCount > 0) {
        this.displayToast(`${fileCount} ${fileLabel} ${label}`, batchErrorFiles.length > 0 ? 'error' : 'success');
      }
      this.adjustTextareaHeight();
    });
  }
  handleToastClick(event) {
    event.stopPropagation();
    this.toastType === 'error' ? this.scrollToBottomOfAttachments() : this.scrollToTopOfAttachments();
  }
  get isSendDisabled() {
    const charExceeded = this.charactersLimit !== undefined && this.message.length > this.charactersLimit;
    return (this.disabled ||
      (!this.message.trim() && this.successAttachmentsList.length === 0) ||
      this.errorAttachmentsList.length > 0 ||
      charExceeded);
  }
  render() {
    const allFiles = [...this.successAttachmentsList, ...this.errorAttachmentsList];
    const charExceeded = this.charactersLimit && this.message.length > this.charactersLimit;
    return (h(Host, { class: this.hostCssClasses(), exportparts: "chat-input-container, toast, input-area, attachments, text-input, actions-bar, left-actions, right-actions, file-item", onClick: this.handleClick }, h("div", { class: this.chatInputContainerClasses(), part: "chat-input-container" }, this.showToast && (h("wpp-toast-v2-21-0", { message: this.toastMessage, type: this.toastType, duration: TOAST_DURATION, variant: "chat", part: "toast", class: this.chatToastClasses(), onClick: event => this.handleToastClick(event) })), h("div", { class: this.inputAreaClasses(), ref: el => (this.inputAreaRef = el), part: "input-area" }, allFiles?.length > 0 && (h("div", { class: this.attachmentsWrapperClasses(), part: "attachments" }, allFiles.map((file, index) => (h("wpp-file-upload-item-v2-21-0", { key: index, file: file, format: this.mergedFileUploadConfig.format, maxLabelLength: this.mergedFileUploadConfig.maxLabelLength, currentIndex: index, onWppDelete: this.handleDeleteItem, onWppClick: this.handleClickItem, locales: {
        sizeError: this.mergedFileUploadConfig.locales?.sizeError || 'File exceeds size limit',
        formatError: this.mergedFileUploadConfig.locales?.formatError || 'Wrong format',
      }, part: "file-item", class: this.isFileWithError(file) ? 'error' : '' }))))), h("textarea", { class: this.textInputClasses(), placeholder: this.placeholder, value: this.message, ref: el => (this.textareaRef = el), onInput: event => this.handleInput(event), disabled: this.disabled, part: "text-input" })), h("div", { class: this.actionsBarClasses(), part: "actions-bar" }, h("div", { class: this.leftActionsClasses(), part: "left-actions" }, this.enableAttach && (h(Fragment, null, h("wpp-action-button-v2-21-0", { "data-testid": "attach-icon-only-button", disabled: this.disabled, variant: "secondary", onClick: () => this.handleFileSelection() }, h("wpp-icon-attach-v2-21-0", { slot: "icon-start" })), h("input", { class: "file-loader", type: "file", ref: inputRef => (this.inputRef = inputRef), style: { display: 'none' }, multiple: this.mergedFileUploadConfig.multiple, onChange: this.handleChange, accept: this.getAcceptExtensions().join(), title: "" }))), this.withSelect && (h(WrappedSlot, { wrapperClass: this.selectClasses(), name: "select", onSlotchange: this.updateSlotData })), this.enableMic && (h("wpp-action-button-v2-21-0", { "data-testid": "mic-icon-only-button", variant: "secondary", disabled: this.disabled }, h("wpp-icon-mic-on-v2-21-0", { slot: "icon-start" })))), h("div", { class: this.rightActionsClasses(), part: "right-actions" }, charExceeded && (h("wpp-typography-v2-21-0", { class: "char-counter", type: "xs-midi" }, this.message.length, "/", this.charactersLimit)), h("wpp-action-button-v2-21-0", { "data-testid": "send-icon-only-button", variant: "secondary", onClick: () => this.handleSend(), disabled: this.isSendDisabled }, h("wpp-icon-send-v2-21-0", { slot: "icon-start" })))))));
  }
  static get registryIs() { return "wpp-chat-input-v2-21-0"; }
  get host() { return this; }
  static get watchers() { return {
    "attachments": ["onAttachmentsChange"]
  }; }
  static get style() { return wppChatInputCss; }
}, [1, "wpp-chat-input", "wpp-chat-input-v2-21-0", {
    "placeholder": [1],
    "enableAttach": [4, "enable-attach"],
    "enableMic": [4, "enable-mic"],
    "disabled": [4],
    "fileUploadConfig": [16],
    "charactersLimit": [2, "characters-limit"],
    "attachments": [1040],
    "withSelect": [516, "with-select"],
    "message": [32],
    "successAttachmentsList": [32],
    "errorAttachmentsList": [32],
    "toastMessage": [32],
    "toastType": [32],
    "showToast": [32],
    "isAnyFileUploading": [32],
    "areAttachmentsVisible": [32],
    "hasSelectSlot": [32]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-chat-input-v2-21-0", "wpp-action-button-v2-21-0", "wpp-file-upload-item-v2-21-0", "wpp-icon-attach-v2-21-0", "wpp-icon-blockquote-v2-21-0", "wpp-icon-bold-v2-21-0", "wpp-icon-code-view-v2-21-0", "wpp-icon-cross-v2-21-0", "wpp-icon-database-v2-21-0", "wpp-icon-document-v2-21-0", "wpp-icon-error-v2-21-0", "wpp-icon-file-v2-21-0", "wpp-icon-file-zip-v2-21-0", "wpp-icon-float-center-v2-21-0", "wpp-icon-float-left-v2-21-0", "wpp-icon-float-right-v2-21-0", "wpp-icon-h1-v2-21-0", "wpp-icon-h2-v2-21-0", "wpp-icon-image-v2-21-0", "wpp-icon-indent-decrease-v2-21-0", "wpp-icon-indent-increase-v2-21-0", "wpp-icon-info-v2-21-0", "wpp-icon-italic-v2-21-0", "wpp-icon-link-v2-21-0", "wpp-icon-mic-on-v2-21-0", "wpp-icon-music-v2-21-0", "wpp-icon-ordered-list-v2-21-0", "wpp-icon-pitch-v2-21-0", "wpp-icon-redo-v2-21-0", "wpp-icon-send-v2-21-0", "wpp-icon-spreadsheet-v2-21-0", "wpp-icon-strike-through-v2-21-0", "wpp-icon-success-v2-21-0", "wpp-icon-text-alignment-center-v2-21-0", "wpp-icon-text-alignment-justify-v2-21-0", "wpp-icon-text-alignment-left-v2-21-0", "wpp-icon-text-alignment-right-v2-21-0", "wpp-icon-underline-v2-21-0", "wpp-icon-undo-v2-21-0", "wpp-icon-unordered-list-v2-21-0", "wpp-icon-video-clip-v2-21-0", "wpp-icon-warning-v2-21-0", "wpp-inline-message-v2-21-0", "wpp-internal-tooltip-v2-21-0", "wpp-spinner-v2-21-0", "wpp-toast-v2-21-0", "wpp-tooltip-v2-21-0", "wpp-typography-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-chat-input-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppChatInput$1);
      }
      break;
    case "wpp-action-button-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$M();
      }
      break;
    case "wpp-file-upload-item-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$L();
      }
      break;
    case "wpp-icon-attach-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$K();
      }
      break;
    case "wpp-icon-blockquote-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$J();
      }
      break;
    case "wpp-icon-bold-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$I();
      }
      break;
    case "wpp-icon-code-view-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$H();
      }
      break;
    case "wpp-icon-cross-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$G();
      }
      break;
    case "wpp-icon-database-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$F();
      }
      break;
    case "wpp-icon-document-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$E();
      }
      break;
    case "wpp-icon-error-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$D();
      }
      break;
    case "wpp-icon-file-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$C();
      }
      break;
    case "wpp-icon-file-zip-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$B();
      }
      break;
    case "wpp-icon-float-center-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$A();
      }
      break;
    case "wpp-icon-float-left-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$z();
      }
      break;
    case "wpp-icon-float-right-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$y();
      }
      break;
    case "wpp-icon-h1-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$x();
      }
      break;
    case "wpp-icon-h2-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$w();
      }
      break;
    case "wpp-icon-image-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$v();
      }
      break;
    case "wpp-icon-indent-decrease-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$u();
      }
      break;
    case "wpp-icon-indent-increase-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$t();
      }
      break;
    case "wpp-icon-info-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$s();
      }
      break;
    case "wpp-icon-italic-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$r();
      }
      break;
    case "wpp-icon-link-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$q();
      }
      break;
    case "wpp-icon-mic-on-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$p();
      }
      break;
    case "wpp-icon-music-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$o();
      }
      break;
    case "wpp-icon-ordered-list-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$n();
      }
      break;
    case "wpp-icon-pitch-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$m();
      }
      break;
    case "wpp-icon-redo-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$l();
      }
      break;
    case "wpp-icon-send-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$k();
      }
      break;
    case "wpp-icon-spreadsheet-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$j();
      }
      break;
    case "wpp-icon-strike-through-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$i();
      }
      break;
    case "wpp-icon-success-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$h();
      }
      break;
    case "wpp-icon-text-alignment-center-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$g();
      }
      break;
    case "wpp-icon-text-alignment-justify-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$f();
      }
      break;
    case "wpp-icon-text-alignment-left-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$e();
      }
      break;
    case "wpp-icon-text-alignment-right-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$d();
      }
      break;
    case "wpp-icon-underline-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$c();
      }
      break;
    case "wpp-icon-undo-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$b();
      }
      break;
    case "wpp-icon-unordered-list-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$a();
      }
      break;
    case "wpp-icon-video-clip-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$9();
      }
      break;
    case "wpp-icon-warning-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$8();
      }
      break;
    case "wpp-inline-message-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "wpp-internal-tooltip-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "wpp-spinner-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "wpp-toast-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "wpp-tooltip-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "wpp-typography-v2-21-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const WppChatInput = WppChatInput$1;
const defineCustomElement = defineCustomElement$1;

export { WppChatInput, defineCustomElement };
